import { makeStyles } from 'tss-react/mui';

const TEXT_SECTION = 'textSection';
const PLACEHOLDER_SECTION = 'placeholderSection';
const STEPPER_SECTION = 'stepperSection';

const useStyles = makeStyles<{ hasStepper: boolean; hasSubLabel: boolean }>()((theme, { hasStepper, hasSubLabel }) => ({
  root: hasStepper
    ? {
        display: 'grid',
        gridTemplateColumns: '1.5fr 1fr 1.5fr',
        gridTemplateAreas: `"${TEXT_SECTION} ${STEPPER_SECTION} ${PLACEHOLDER_SECTION}"`,
        marginBottom: theme.spacing(1.5),
        [theme.breakpoints.down('md')]: {
          gridTemplateColumns: '1fr',
          gridTemplateAreas: `
            "${TEXT_SECTION}"
            "${PLACEHOLDER_SECTION}"
            "${STEPPER_SECTION}"
          `,
          paddingLeft: theme.spacing(2),
          paddingRight: theme.spacing(2),
        },
      }
    : {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: hasSubLabel ? theme.spacing(3) : theme.spacing(2),
        marginTop: hasSubLabel ? theme.spacing(3) : theme.spacing(2),
        [theme.breakpoints.down('md')]: {
          alignItems: 'flex-start',
          flexDirection: 'column',
        },
        [theme.breakpoints.down('sm')]: {
          paddingLeft: theme.spacing(0),
          paddingRight: theme.spacing(0),
        },
      },

  textContainer: {
    gridArea: TEXT_SECTION,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(0, 1.75),
    },
  },

  headerContainer: {
    display: 'flex',
    alignItems: 'center',
  },

  iconContainer: {
    borderRadius: theme.shape.borderRadius,
    width: hasSubLabel ? '50px' : '35px',
    height: hasSubLabel ? '50px' : '35px',
    padding: theme.spacing(1),
    backgroundColor: '#fff',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: theme.spacing(2),
  },

  extraAfterIconComponent: {
    marginRight: theme.spacing(2),
  },

  title: {
    fontSize: hasSubLabel ? '0.9rem' : '1.1rem',
    lineHeight: hasSubLabel ? '1.5rem' : '1.875rem',
  },

  subTitle: {
    fontSize: '1.5rem',
  },

  divider: {
    gridArea: PLACEHOLDER_SECTION,
    width: '100%',
    display: 'none',
    [theme.breakpoints.down('md')]: {
      display: 'block',
      margin: theme.spacing(3, 0),
    },
  },

  stepper: {
    gridArea: STEPPER_SECTION,
    display: 'flex',
    justifyContent: 'center',
  },
}));

export default useStyles;
